const dailyTagValues = state => state.dailyTagValues
const tagValues = state => state.tagValues
const treeData = state => state.treeData
const tags = state => state.tags
const availableTags = state => state.availableTags
const status = state => state.status
export default {
    dailyTagValues,
    tagValues,
    treeData,
    tags,
    availableTags,
    status
}
